<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>申報年度</td>
                  <td colspan="3">
                    <select v-model="form.syear">
                      <option
                        v-for="(data, index) in dropDownList.syears"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <input
                      type="submit"
                      class="btn"
                      value="操作說明"
                      @click="BtnExplain()"
                    />
                  </td>
                </tr>
                <tr>
                  <td>受理申報機關</td>
                  <td colspan="3">
                    <select
                      v-model="form.jobGovCode1"
                      style="min-width: 200px"
                      @change="JobGovCode1Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode2"
                      style="min-width: 200px"
                      @change="JobGovCode2Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        2 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode3"
                      style="min-width: 200px"
                      @change="JobGovCode3Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        3 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        4 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.jobGovCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>身分證統一編號</td>
                  <td>
                    <input type="text" v-model="form.idn" />
                  </td>
                  <td>姓名</td>
                  <td>
                    <input type="text" v-model="form.name" />
                  </td>
                </tr>
                <tr>
                  <td>匯出格式</td>
                  <td colspan="3">
                    <p>
                      <label>
                        <input
                          type="radio"
                          checked="checked"
                          value="XLSX"
                          v-model="form.printtype"
                        />
                        XLSX</label
                      >
                      <label>
                        <input
                          type="radio"
                          v-model="form.printtype"
                          value="ODS"
                          checked="checked"
                          display
                        />
                        ODS</label
                      >
                    </p>
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="查詢"
                          @click="
                            () => {
                              this.form.currentpage = 1;
                              this.form.pagesize = 10;
                              this.doQuery();
                            }
                          "
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="匯出上傳筆數"
                          @click="BtnSearchCount()"
                        />
                        <!-- onclick="location.href='上傳筆數.XLSX'"-->
                        <input
                          type="submit"
                          class="btn"
                          value="重填"
                          @click="btnClear()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <input
                    type="submit"
                    class="btn"
                    value="匯入"
                    @click="BtnImport()"
                  />
                  <input
                    type="button"
                    class="btn"
                    value="匯出抽籤名單"
                    @click="ExportModalBtnExport()"
                  />
                  請參考【操作說明】
                </td>
                <td align="right" v-if="grid.paginaiton">
                  <input
                    type="button"
                    value="<<"
                    class="btn"
                    style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1"
                    v-show="grid.paginaiton.pageNo > 1"
                  />
                  <span
                    v-for="(data, index) in grid.paginaiton.pages"
                    :key="index"
                    style="cursor: pointer"
                    :style="
                      grid.paginaiton.pageNo == data
                        ? 'color:red'
                        : 'color:black'
                    "
                    @click="form.currentpage = parseInt(data)"
                  >
                    {{
                      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
                    }}
                  </span>
                  <input
                    type="button"
                    class="btn"
                    value=">>"
                    style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1"
                  />
                  ［每頁<input
                    type="text"
                    v-model.number.lazy="form.pagesize"
                    size="2"
                    maxlength="4"
                  />

                  <input type="button" class="btn" value="筆" />，第<input
                    type="text"
                    v-model.number.lazy="form.currentpage"
                    size="2"
                    maxlength="4"
                  />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th>操作</th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('SYEAR', Sort);
                          }
                        "
                        >申報年度</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('NAME', Sort);
                          }
                        "
                        >姓名</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('IDN', Sort);
                          }
                        "
                        >身分證統一編號</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('GOV_NAME', Sort);
                          }
                        "
                        >受理申報機關</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('CT_DATE', Sort);
                          }
                        "
                        >匯入日期</u
                      >
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        @click="btnDelete(data)"
                        value="刪"
                      />
                    </td>
                    <td>{{ data.syear }}</td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.idn }}</td>
                    <td>{{ data.goV_NAME }}</td>
                    <td>{{ data.cT_DATE }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <PdisFooter />
    <ImportModal
      v-model="ImportModal.show"
      :title="ImportModal.title"
      :modalStyle="{ 'max-width': '1280px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>申報年度</td>
                <td colspan="3">
                  <select v-model="ImportModal.syear">
                    <option
                      v-for="(data, index) in dropDownList.syears"
                      :key="index"
                      :value="data"
                    >
                      {{ data }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>受理申報機關</td>
                <td colspan="3">
                  <select
                    v-model="ImportModal.jobGovCode1"
                    style="min-width: 200px"
                    @change="ImportModalJobGovCode1Change()"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      1 <= loginInfo.layerNum
                    "
                  >
                    <option
                      v-for="(item, index) in dropDownList.jobGovCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="ImportModal.jobGovCode2"
                    style="min-width: 200px"
                    @change="ImportModalJobGovCode2Change()"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      2 <= loginInfo.layerNum
                    "
                  >
                    <option
                      v-for="(item, index) in dropDownList.jobGovCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="ImportModal.jobGovCode3"
                    style="min-width: 200px"
                    @change="ImportModalJobGovCode3Change()"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      3 <= loginInfo.layerNum
                    "
                  >
                    <option
                      v-for="(item, index) in dropDownList.jobGovCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="ImportModal.jobGovCode4"
                    style="min-width: 200px"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      4 <= loginInfo.layerNum
                    "
                  >
                    <option
                      v-for="(item, index) in dropDownList.jobGovCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>上傳檔案</td>
                <td>
                  <input
                    type="file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    @change="ImportModalOnFileChange"
                  />
                  <input
                    type="submit"
                    class="btn"
                    value="匯入"
                    @click="ImportModalBtnImportCheck()"
                  />
                </td>
              </tr>
              <tr>
                <td>說明</td>
                <td>
                  <p>
                    請下載此範本<a
                      href="/PdpsCli/download/F105_sample.xls"
                      target="_blank"
                      >sample.xls</a
                    >
                  </p>
                  <!-- 【使用說明】：<br />
                    1. 上傳格式說明<br />
                    2.請先下載此範本<a
                      href="/PdpsCli/download/F105_sample.xls"
                      target="_blank"
                      >sample.xls</a
                    ><br />
                    3.依範本方式輸入需要的各項資料(300筆以內)<br />
                    4.儲存檔案 (副檔名需存成.xls)<br />
                    5.再按下上方的「選擇檔案」按鈕，選擇剛儲存的檔案<br />
                    6.按下「匯入」按鈕<br />
                    7.在欲不匯入的名單做刪除，按下確認匯入。(不符合系統規則的資料，則無法進行匯入)
                   7.在欲匯入的名單前做打勾，按下確認匯入。(不符合系統規則的資料，則無法進行匯入)-->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 查詢結果開始-->
        <table
          width="1060"
          class="itable"
          v-if="ImportModal.grid && ImportModal.grid.length > 0"
        >
          <thead>
            <tr>
              <th>項次</th>
              <th>年度</th>
              <th>任職機關代碼</th>
              <th>受理申報機關代碼</th>
              <th>職稱</th>
              <th>身分證統一編號</th>
              <th>姓名</th>
              <th>備註</th>
              <th>管理</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in ImportModal.grid" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ data.syear }}</td>
              <td>{{ data.joB_GOV_CODE }}</td>
              <td>{{ data.goV_CODE }}</td>
              <td>{{ data.title }}</td>
              <td>{{ data.idn }}</td>
              <td>{{ data.name }}</td>
              <td>{{ data.erroR_MSG }}</td>
              <td>
                <input
                  type="button"
                  class="btn"
                  value="刪"
                  @click="ImportModalDelete(index)"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 查詢結果結束-->
        <div
          class="f_center"
          v-if="ImportModal.grid && ImportModal.grid.length > 0"
        >
          <input
            type="submit"
            class="btn"
            value="確認匯入"
            @click="ImportModalBtnImportSubmit()"
          />
        </div>
      </div>
    </ImportModal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
    <AlertDel v-model="AlertDel.show" :title="AlertDel.title">
      <div style="text-align: center">
        <p>確定要刪除資料嗎?</p>
        <div>
          <button class="btn" @click="btnDelSubmit()">確定</button>
          <button class="btn" @click="AlertDel.show = false">取消</button>
        </div>
      </div>
    </AlertDel>
    <AlertExplain v-model="AlertExplain.show" :title="AlertExplain.title">
      <div style="text-align: left">
        <p>
          1.可透過【匯出抽籤名單】產製名單確認後直接匯入，亦可透過【匯入】下載空白範本自行編輯完成後再行匯入。
        </p>
        <p>
          2.注意：【匯出抽籤名單】係依C101資料所產製之名單，僅供參考及編輯使用，仍請受理申報單位依實際抽籤名單維護後匯入。
        </p>
        <div style="text-align: center">
          <button class="btn" @click="AlertExplain.show = false">確定</button>
        </div>
      </div>
    </AlertExplain>
    <AlertImport v-model="AlertImport.show" :title="AlertImport.title">
      <div style="text-align: center">
        <p>
          {{ AlertImport.txt }}
        </p>
        <div>
          <button class="btn" @click="ImportModalBtnImport()">確定</button>
          <button class="btn" @click="AlertImport.show = false">取消</button>
        </div>
      </div>
    </AlertImport>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenuIndex, getMenu, logOut } from "@/config/util.js";
import {
  SearchGovCode,
  F105_SearchGrid,
  F105_ReSearchGrid,
  F105_SearchCount,
  F105_SearchTeam,
  F105_Import,
  F105_ImportCheck,
  F105_ImportTemp,
  F105_ImportSubmit,
  F105_PrintReport,
  F105_Delete,
} from "@/service/api.js";
export default {
  name: "F105",
  data: function () {
    return {
      pageData: {
        MenuIndex: 4,
        MenuName: "",
        PrgName: "F105",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      SessionGovCode: sessionStorage.getItem("Session_GovCode"),
      Order: "",
      Sort: "",
      form: {
        idn: "",
        name: "",
        syear: (new Date().getFullYear() - 1912).toString(), //"111",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        ImportType: "XLSX",
        pagesize: 10,
        currentpage: 1,
        printtype: "XLSX",
      },
      dropDownList: {
        jobGovCode1s: [],
        jobGovCode2s: [],
        jobGovCode3s: [],
        jobGovCode4s: [],
        syears: [],
      },
      grid: [],
      ImportModal: {
        syear: (new Date().getFullYear() - 1912).toString(),
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        show: false,
        title: "F105抽籤名單匯入-匯入",
        form: {
          updloaD_FILE: "",
        },
        dropDownList: {
          jobGovCode1s: [],
          jobGovCode2s: [],
          jobGovCode3s: [],
          jobGovCode4s: [],
        },
        grid: [],
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
      AlertDel: {
        show: false,
        title: "",
        form: {
          pkno: 0,
        },
      },
      AlertExplain: {
        show: false,
        title: "",
        form: {
          pkno: 0,
        },
      },
      AlertImport: {
        show: false,
        title: "",
        form: {
          pkno: 0,
        },
        txt: "",
      },
      host: window.location.host,
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    ImportModal: VueModal,
    Alert: VueModal,
    AlertDel: VueModal,
    AlertExplain: VueModal,
    AlertImport: VueModal,
  },
  methods: {
    getSyearDropDownList: function () {
      let syears = [""];
      const startYear = 99; //民國99年
      for (let i = startYear; i <= new Date().getFullYear() - 1911; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
    //取得受理申報機關第一層類別
    getSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    getSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode2s = rData.returnObject;
      });
    },
    //取得受理申報機關第三層類別
    getSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    getSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    //取得受理申報機關第一層類別
    ImportModalgetSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.ImportModal.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    ImportModalgetSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.ImportModal.dropDownList.jobGovCode2s = rData.returnObject;
      });
    },
    //取得受理申報機關第三層類別
    ImportModalgetSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.ImportModal.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    ImportModalgetSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.ImportModal.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    BtnExplain: function () {
      const self = this;
      this.AlertExplain.show = true;
      this.AlertExplain.title = "提醒";
    },
    //第一頁查詢
    doQuery: function () {
      const self = this;
      //清空
      self.Order = "";
      self.Sort = "";
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        GOV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        GOVCHECK: parseInt(self.form.jobGovCheck),
        SYEAR: self.form.syear,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        //ImportType: self.form.ImportType,
      };
      F105_SearchGrid(postData).then((rData) => {
        if (rData.result) {
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "IDN";
          self.Sort = "ASC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        GOV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        GOVCHECK: parseInt(self.form.jobGovCheck),
        SYEAR: self.form.syear,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
        //ImportType: self.form.ImportType,
      };
      F105_ReSearchGrid(postData).then((rData) => {
        if (rData.result) {
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //第一頁重填
    btnClear: function () {
      const self = this;
      self.form = {
        idn: "",
        name: "",
        syear: "",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        ImportType: "XLSX",
        pagesize: 10,
        currentpage: 1,
        printtype: "XLSX",
      };
      self.JobGovCodeInit(self.form);
      self.getSearchJobGovCode1();
    },
    JobGovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.jobGovCode1 = self.SessionGovCode;
        form.jobGovCode2 = "";
        form.jobGovCode3 = "";
        form.jobGovCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.jobGovCode1 = govCodeArray[0];
          form.jobGovCode2 = govCodeArray[1];
          form.jobGovCode3 = govCodeArray[2];
          form.jobGovCode4 = govCodeArray[3];
        }
      }
    },
    JobGovCode1Change: function () {
      const self = this;
      self.form.jobGovCode2 = "";
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode2s = [];
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode2Change: function () {
      const self = this;
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode3Change: function () {
      const self = this;
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode4s = [];
    },
    ImportModalJobGovCode1Change: function () {
      const self = this;
      self.ImportModal.jobGovCode2 = "";
      self.ImportModal.jobGovCode3 = "";
      self.ImportModal.jobGovCode4 = "";
      self.ImportModal.dropDownList.jobGovCode2s = [];
      self.ImportModal.dropDownList.jobGovCode3s = [];
      self.ImportModal.dropDownList.jobGovCode4s = [];
    },
    ImportModalJobGovCode2Change: function () {
      const self = this;
      self.ImportModal.jobGovCode3 = "";
      self.ImportModal.jobGovCode4 = "";
      self.ImportModal.dropDownList.jobGovCode3s = [];
      self.ImportModal.dropDownList.jobGovCode4s = [];
    },
    ImportModalJobGovCode3Change: function () {
      const self = this;
      self.ImportModal.jobGovCode4 = "";
      self.ImportModal.dropDownList.jobGovCode4s = [];
    },
    btnDelete: function (data) {
      const self = this;
      this.AlertDel.show = true;
      this.AlertDel.title = "提醒";
      this.AlertDel.form.pkno = data.pkno;
    },
    btnDelSubmit: function () {
      const self = this;
      F105_Delete({
        pkno: this.AlertDel.form.pkno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "刪",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      }).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["刪除成功"];
          self.Alert.BtnConfirm = () => {
            self.doQuery();
            self.Alert.show = false;
            self.AlertDel.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.AlertDel.show = false;
          //self.Alert.txt = "刪除失敗";
          self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第一頁匯入
    BtnImport: function () {
      const self = this;
      self.ImportModal.show = true;
      self.JobGovCodeInit(self.ImportModal);
      self.ImportModalgetSearchJobGovCode1();
    },
    BtnSearchCount: function () {
      const self = this;
      let postData = {
        syear: self.form.syear,
        idn: self.form.idn,
        name: self.form.name,
        goV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        govcheck: parseInt(self.form.jobGovCheck),
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "匯出上傳比數",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        printtype: self.form.printtype,
      };
      if (self.form.printtype == "ODS") {
        F105_SearchCount(postData).then((rData) => {
          if (rData) {
            let link = document.createElement("a");
            link.download = "F105匯出上傳筆數.ods";
            link.href = "data:application/doc;base64," + rData;
            link.click();
          } else {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = rData.messages;
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
            };
          }
        });
      } else {
        // console.log(JSON.stringify(postData));
        F105_SearchCount(postData).then((rData) => {
          if (rData) {
            let link = document.createElement("a");
            link.download = "F105匯出上傳筆數.xlsx";
            link.href =
              "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
              rData;
            // link.href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + rData;
            link.click();
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            //self.Alert.txt = "匯出失敗";
            self.Alert.txt = rData.messages;
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      }
    },
    //匯入頁 按紐匯入//出現是OR否
    ImportModalBtnImportCheck: function () {
      const self = this;
      if (self.ImportModal.form.updloaD_FILE) {
        let formData = new FormData();
        formData.append("UPDLOAD_FILE", self.ImportModal.form.updloaD_FILE);
        formData.append("SYEAR", self.ImportModal.syear);
        formData.append(
          "GOV_CODE",
          self.ImportModal.jobGovCode4
            ? self.ImportModal.jobGovCode4
            : self.ImportModal.jobGovCode3
            ? self.ImportModal.jobGovCode3
            : self.ImportModal.jobGovCode2
            ? self.ImportModal.jobGovCode2
            : self.ImportModal.jobGovCode1
            ? self.ImportModal.jobGovCode1
            : ""
        );
        formData.append("LogInfo.Id", self.loginInfo.id);
        formData.append("LogInfo.PrgCode", self.pageData.PrgName);
        formData.append("LogInfo.ActCd", "匯入");
        formData.append("LogInfo.Token", self.loginInfo.token);
        formData.append("LogInfo.ServiceUnit", self.pageData.ServiceUnit);

        F105_ImportCheck(formData).then((rData) => {
          if (rData.result && rData.messages[0] != "") {
            self.AlertImport.show = true;
            self.AlertImport.title = "訊息";
            self.AlertImport.txt = rData.messages[0]; //"匯入成功";
            self.AlertImport.BtnConfirm = () => (self.AlertImport.show = false);
          } else if (rData.result) {
            self.ImportModalBtnImport();
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt == rData.messages; //
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      } else {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ["請先選取匯入檔案"];
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
      }
    },
    //匯入頁 按紐匯入
    ImportModalBtnImport: function () {
      const self = this;
      self.AlertImport.show = false;
      if (self.ImportModal.form.updloaD_FILE) {
        let formData = new FormData();
        formData.append("UPDLOAD_FILE", self.ImportModal.form.updloaD_FILE);
        formData.append("SYEAR", self.ImportModal.syear);
        formData.append(
          "GOV_CODE",
          self.ImportModal.jobGovCode4
            ? self.ImportModal.jobGovCode4
            : self.ImportModal.jobGovCode3
            ? self.ImportModal.jobGovCode3
            : self.ImportModal.jobGovCode2
            ? self.ImportModal.jobGovCode2
            : self.ImportModal.jobGovCode1
            ? self.ImportModal.jobGovCode1
            : ""
        );
        formData.append("LogInfo.Id", self.loginInfo.id);
        formData.append("LogInfo.PrgCode", self.pageData.PrgName);
        formData.append("LogInfo.ActCd", "匯入");
        formData.append("LogInfo.Token", self.loginInfo.token);
        formData.append("LogInfo.ServiceUnit", self.pageData.ServiceUnit);

        F105_Import(formData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = rData.messages; //"匯入成功";
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt == rData.messages; //
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      } else {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ["請先選取匯入檔案"];
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
      }
    },
    //匯入頁 按紐匯入
    ImportModalBtnImportTemp: function () {
      const self = this;
      if (self.ImportModal.form.updloaD_FILE) {
        //    let formData = {
        //   syear: self.form.syear,
        // };
        let formData = new FormData();
        formData.append("syear", self.ImportModal.syear);
        formData.append(
          "GOV_CODE",
          self.ImportModal.jobGovCode4
            ? self.ImportModal.jobGovCode4
            : self.ImportModal.jobGovCode3
            ? self.ImportModal.jobGovCode3
            : self.ImportModal.jobGovCode2
            ? self.ImportModal.jobGovCode2
            : self.ImportModal.jobGovCode1
            ? self.ImportModal.jobGovCode1
            : ""
        );
        formData.append("UPDLOAD_FILE", self.ImportModal.form.updloaD_FILE);

        F105_ImportTemp(formData).then((rData) => {
          self.ImportModal.grid = rData.returnObject.data;
          if (rData.result) {
            self.ImportModal.grid = rData.returnObject.data;
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["取得資料成功"]; //rData.messages;//"匯入成功";
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = ["取得資料失敗"]; //=rData.messages;//
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      } else {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ["請先選取匯入檔案"];
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
      }
    },
    ImportModalDelete: function (index) {
      const self = this;
      self.ImportModal.grid.splice(index, 1);
    },
    //匯入頁 按紐確認匯入
    ImportModalBtnImportSubmit: function () {
      const self = this;
      let formData = new FormData();
      formData.append("syear", self.ImportModal.syear);
      formData.append(
        "GOV_CODE",
        self.ImportModal.jobGovCode4
          ? self.ImportModal.jobGovCode4
          : self.ImportModal.jobGovCode3
          ? self.ImportModal.jobGovCode3
          : self.ImportModal.jobGovCode2
          ? self.ImportModal.jobGovCode2
          : self.ImportModal.jobGovCode1
          ? self.ImportModal.jobGovCode1
          : ""
      );

      let formList = new Array();
      self.ImportModal.grid.forEach((x) => formList.push(x));
      //console.log(arrayToList(self.ImportModal.grid));
      formData.append("tempgrid", formList);

      F105_ImportSubmit(formData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = [rData.messages]; //"匯入成功";
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = [rData.messages]; //
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //匯出頁 按紐匯出
    ExportModalBtnExport: function () {
      const self = this;
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        GOV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        GOVCHECK: parseInt(self.form.jobGovCheck),
        SYEAR: self.form.syear,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "匯出抽籤名單",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        printtype: self.form.printtype,
      };
      // console.log(JSON.stringify(postData));
      if (self.form.printtype == "ODS") {
        F105_PrintReport(postData).then((rData) => {
          if (rData) {
            let link = document.createElement("a");
            link.download = "F102.ods";
            link.href = "data:application/doc;base64," + rData;
            link.click();
          } else {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = rData.messages;
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
            };
          }
        });
      } else {
        F105_PrintReport(postData).then((rData) => {
          if (rData) {
            self.Alert.show = true;
            self.Alert.title = "正確";
            self.Alert.txt = ["匯出成功"];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);

            let link = document.createElement("a");
            link.download = "F105抽籤名單匯入";
            link.href =
              "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
              rData;
            // link.href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + rData;
            link.click();
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            //self.Alert.txt = "匯出失敗";
            self.Alert.txt = rData.messages;
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      }
    },
    //匯入頁
    ImportModalOnFileChange: function (event) {
      const self = this;
      self.ImportModal.form.updloaD_FILE = event.target.files[0];
    },
  },
  watch: {
    "form.jobGovCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode2(newValue);
    },
    "form.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode3(newValue);
    },
    "form.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode4(newValue);
    },
    "ImportModal.jobGovCode1": function (newValue, oldValue) {
      if (newValue != "") this.ImportModalgetSearchJobGovCode2(newValue);
    },
    "ImportModal.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.ImportModalgetSearchJobGovCode3(newValue);
    },
    "ImportModal.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.ImportModalgetSearchJobGovCode4(newValue);
    },
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.dropDownList.syears = self.getSyearDropDownList();
    self.JobGovCodeInit(self.form);
    self.getSearchJobGovCode1();
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
